//单站概览
const stationOverviewZh = {
  staOverLang: {
    请输入站点名称搜索: '请输入站点名称搜索',
    暂无数据: '暂无数据',
    创建电站: '创建电站',
    今日充电量: '今日充电量',
    较昨日下降: '较昨日下降',
    较昨日增长: '较昨日增长',
    月充电: '月充电',
    累计充电: '累计充电',
    今日放电量: '今日放电量',
    月放电: '月放电',
    累计放电: '累计放电',
    今日收益: '今日收益',
    元: '元',
    本月收益: '本月收益',
    万元: '万元',
    总收益: '总收益',
    发生中告警: '发生中告警',
    条: '条',
    查看详细: '查看详细',
    运维处理: '运维处理',
    无需关注: '无需关注',
    站点信息: '站点信息',
    暂无站点图片: '暂无站点图片',
    点击上传: '点击上传',
    装机总容量: '装机总容量',
    装机功率: '装机功率',
    投运时间: '投运时间',
    电站地址: '电站地址',
    查看电站: '查看电站',
    基础信息: '基础信息',
    更多信息: '更多信息',
    电站图片: '电站图片',
    装机容量: '装机容量',
    电站联系电话: '电站联系电话',
    安装图片: '安装图片',
    并网点信息: '并网点信息',
    有光伏: '有光伏',
    无光伏: '无光伏',
    有并网点: '有并网点',
    无并网点: '无并网点',
    其它: '其它',
    变压器信息: '变压器信息',
    站点变压器容量: '站点变压器容量',
    安装人: '安装人',
    安装人联系号码: '安装人联系号码',
    关闭: '关闭',
    综合效率: '综合效率',
    '指单位时间内的电站放电量 ÷ 充电量': '指单位时间内的电站放电量 ÷ 充电量',
    近7日: '近7日',
    近31日: '近31日',
    近12月: '近12月',
    开始日期: '开始日期',
    结束日期: '结束日期',
    放电达成率: '放电达成率',
    '指单位时间内的电站放电量 ÷（装机容量 × 放电天数），放电天数指实际放电大于 0 的天数': '指单位时间内的电站放电量 ÷（装机容量 × 放电天数），放电天数指实际放电大于 0 的天数',
    本周: '本周',
    本月: '本月',
    本年: '本年',
    收益统计: '收益统计',
    充放电统计: '充放电统计',
    收益: '收益',
    系统列表: '系统列表',
    通讯状态: '通讯状态',
    全部: '全部',
    在线: '在线',
    离线: '离线',
    请输入内容: '请输入内容',
    查询: '查询',
    重置: '重置',
    导出: '导出',
    系统编号: '系统编号',
    系统名称: '系统名称',
    在线状态: '在线状态',
    今日充放电量: '今日充放电量',
    累计充放电量: '累计充放电量',
    运维处理今日: '运维处理今日',
    电网有功功率: '电网有功功率',
    储能有功功率: '储能有功功率',
    负载有功功率: '负载有功功率',
    序号: '序号',
    请选择站点: '请选择站点'
  }
}
export default stationOverviewZh
